module.exports = __webpack_public_path__ + "img/wx-xcx.73c8799f.jpg";